module.exports = __webpack_public_path__ + "img/price-icon5.e20f1863.png";